export const createDownloadLink = (
	source: Blob | string,
	fileName: string
): void => {
	const isBlob = source instanceof Blob
	const url = isBlob ? URL.createObjectURL(source) : source
	const link = document.createElement('a')
	link.style.display = 'none'
	link.href = url
	link.download = fileName

	if (isBlob) {
		link.target = '_blank'
	}

	document.body.appendChild(link)
	link.click()

	if (isBlob) {
		URL.revokeObjectURL(url)
	}

	document.body.removeChild(link)
}
